import { Outlet } from "react-router";
import style from "./Login.module.css";
import CompactFooter from "@/shared/components/footer/CompactFooter";
import { useRegistrationFlowCleanup } from "../hooks";

export const LoginLayout = () => {
    // Limpiar localStorage cuando el usuario salga del flujo de registro
    useRegistrationFlowCleanup();

    return (
        <div className={`${style.rows} bg-[var(--color-blue-dark)]`}>
            <main className="flex flex-wrap justify-between items-stretch bg-white rounded-b-[50px] overflow-y-auto mb-4">
                <Outlet />
            </main>
            <CompactFooter variant="minimal" />
        </div>
    );
}